import { useTheme } from '@emotion/react'
import { useStaticQuery, graphql } from 'gatsby'
import {
  Section,
  Container,
  Row,
  RowColumn,
  Inline,
  ListItem,
} from 'chaoskit/src/components'

import GradientList from '../global/GradientList'

import Data from '~components/Data'
import ButtonLink from '~components/ButtonLink'
import { textGradientUnderline } from '~styles/utility'

const SafeSimple = () => {
  const theme = useTheme()

  const {
    file: {
      childMdx: {
        frontmatter: { safeSimple: pageData },
      },
    },
  } = useStaticQuery(graphql`
    query SafeSimplePageData {
      file(name: { eq: "home" }, absolutePath: { regex: "/src/data/" }) {
        childMdx {
          frontmatter {
            safeSimple {
              heading
              blurb
              items {
                blurb
              }
              ctas {
                label
                url
              }
            }
          }
        }
      }
    }
  `)

  return (
    <Section space="xlarge">
      <Container>
        <Row gutter={{ base: 'xlarge' }}>
          <RowColumn
            size={{ medium: 6 }}
            css={{
              [theme.mq.small__max]: {
                textAlign: 'center',
              },
            }}
          >
            <h3 css={{ ...theme.headingPreset.h2 }}>
              <span css={[textGradientUnderline(theme)]}>
                {pageData.heading}
              </span>
            </h3>
            <div css={{ marginBottom: theme.space.large }}>
              <Data>{pageData.blurb}</Data>
            </div>

            <Inline
              css={{
                [theme.mq.small__max]: {
                  justifyContent: 'center',
                },
              }}
            >
              {pageData.ctas.map((cta, index) => (
                <ListItem key={cta.label}>
                  <ButtonLink
                    type={index === 0 ? 'primary' : 'secondary'}
                    url={cta.url}
                  >
                    {cta.label}
                  </ButtonLink>
                </ListItem>
              ))}
            </Inline>
          </RowColumn>
          <RowColumn size={{ medium: 6 }}>
            <GradientList items={pageData.items} />
          </RowColumn>
        </Row>
      </Container>
    </Section>
  )
}

export default SafeSimple
